import React from 'react';
import styled from 'styled-components';
import media from 'src/styles/media';
import { t, getBaseLocaleURL } from 'src/utils/translate';
import { I18n } from 'react-i18next';
import ReCAPTCHA from "react-google-recaptcha";

import Input from './elements/Input';
import Select from './elements/Select';
import Checkbox from './elements/Checkbox';
import Button from 'components/Button';
// import Recaptcha from './elements/Recaptcha';

let isRecaptchaVerify = false;

const Form = () => {

  const onChange = () => {
    isRecaptchaVerify = true;
  }

  const handleClick = (e) => {
    if (!isRecaptchaVerify) {
      e.preventDefault();
      alert('Please verify the Recaptcha. Thank you!');
    }
  }

  return (
    <I18n>
      {(translate, { i18n }) => {
        return (
          <Root
            action="https://gateway.rennie.com/leads"
            // action="https://go.pardot.com/l/677113/2019-04-26/77mt"
            method="POST"
          >
            {/* <Recaptcha /> */}
            <input
              type="hidden"
              name="captcha_settings"
              value='{"keyname":"IVYONTHEPARK","fallback":"true","orgId":"00Dj0000000HQIU","ts":""}'
            />
            <TitleWrapper>
              <h1>{t('register.title')}</h1>
              <h2>| {t('register.subtitle')} |</h2>
            </TitleWrapper>
            <Fileds>
              <Input
                label={t('register.form.firstName')}
                id="first_name"
                name="first_name"
                required
              />
              <Input
                label={t('register.form.lastName')}
                id="last_name"
                name="last_name"
                required
              />
              <Input
                label={t('register.form.email')}
                type="email"
                id="email"
                name="email"
                required
              />
              <Input
                label={t('register.form.city')}
                id="city"
                name="city"
                required
              />
              <Input
                label={t('register.form.postal')}
                id="zip"
                name="zip"
                required
              />
              <Input label={t('register.form.phone')} id="phone" name="phone" />

              <Select
                id="00Nj0000000gK0N"
                name="00Nj0000000gK0N"
                defaultValue=""
                label={t('register.form.realtor')}
                required
              >
                <option value="" disabled>
                  {t('register.form.realtor')}
                </option>
                <option value="yes">{t('register.form.yes')}</option>
                <option value="no">{t('register.form.no')}</option>
              </Select>

              <Select
                id="00Nj000000AITER"
                name="00Nj000000AITER"
                defaultValue=""
                label={t('register.form.hear')}
              >
                <option value="" disabled>
                  {t('register.form.hear')}
                </option>
                <option value="Signage/Walk by/Drive by">
                  {t('register.form.hearOptions.0')}
                </option>
                <option value="Friends and Family">
                  {t('register.form.hearOptions.1')}
                </option>
                <option value="Newspaper Advertisement">
                  {t('register.form.hearOptions.2')}
                </option>
                <option value="Magazine Advertisement">
                  {t('register.form.hearOptions.3')}
                </option>
                <option value="Social Media">
                  {t('register.form.hearOptions.4')}
                </option>
                <option value="Realtor">
                  {t('register.form.hearOptions.5')}
                </option>
                <option value="Online Advertisement">
                  {t('register.form.hearOptions.6')}
                </option>
                <option value="Direct Mailer">
                  {t('register.form.hearOptions.7')}
                </option>
                <option value="Other">
                  {t('register.form.hearOptions.8')}
                </option>
              </Select>

              <Checkbox
                htmlId="00Nj0000000kXHD"
                name="00Nj0000000kXHD"
                value="1"
                required
                label={t('register.form.consent')}
              />
            </Fileds>
            ]
            <ButtonContainer>
              {/* <div
                className="g-recaptcha"
                data-sitekey="6Lch8pkUAAAAAMpglhpc3Df0ZgTWjwdlYVY4foTr"
              /> */}
              <ReCAPTCHA
                // ref={recaptchaRef}
                sitekey="6Lch8pkUAAAAAMpglhpc3Df0ZgTWjwdlYVY4foTr"
                onChange={onChange}
              />
              <br />
            </ButtonContainer>
            <Button type="submit" onClick={handleClick}>{t('register.form.submit')}</Button>
            {/* <input type="hidden" name="oid" value="00Dj0000000HQIU" />
            <input type="hidden" id="P00Nj0000000lna3" name="00Nj0000000lna3" value="Ivy on the Park" /> */}
            <input type="hidden" name="00N3Z00000CeVw2" value="7013Z0000033kvaQAA" />
            <input type="hidden" name="00N3Z00000CeVw3" value="a04f100000UlCPBAA3" />
            <input type="hidden" name="00N3Z00000CeYiQ" value="1" />
            <input name="00N3Z00000CeVvt" type="hidden" value="Project Site" />
            <input name="00N3Z00000CeVw9" type="hidden" value="Web Source" />
            <input name="00N3Z00000CeVw1" type="hidden" value="Web Registration" />
            <input
              type="hidden"
              name="retURL"
              value={`http://ivyonthepark.com${getBaseLocaleURL(
                i18n
              )}/thankyou/`}
            />
             
            
          </Root>
        );
      }}
    </I18n>
  );
};

const Root = styled.form`
  text-align: center;
  .g-recaptcha {
    margin: 0 auto;
  }
`;

const Fileds = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-flow: row wrap;
  width: 50%;
  margin: 0 auto;
  @media (max-width: ${media.md}) {
    width: 100%;
  }
  > * {
    flex: 0 0 47%;
    margin-bottom: 45px;
    @media (max-width: ${media.md}) {
      flex: 0 0 100%;
    }
    &:last-child {
      flex: 0 1 100%;
    }
  }
`;

const TitleWrapper = styled.div`
  margin-bottom: 75px;

  h1 {
    font-family: GaramondPremrPro;
    font-size: 36px;
    color: #ffffff;
    letter-spacing: 4.5px;
    text-align: center;
    text-transform: uppercase;
  }

  h2 {
    font-family: HelveticaNeue-Bold;
    font-size: 11px;
    color: #ffffff;
    letter-spacing: 1.83px;
    text-align: center;
    text-transform: uppercase;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export default Form;



// WEBPACK FOOTER //
// ./src/pages/Register/elements/Form/Form.js